function getLocalTimeFromInstant(time, useUTC = false) {
    if (!time) {
        return null
    }

    const isLocalTimeFormat = /^\d{2}:\d{2}:\d{2}$/.test(time);

    if (isLocalTimeFormat) {
        return time
    }

    const date = new Date(time);

    const hours = useUTC ? date.getUTCHours() : date.getHours();
    const minutes = useUTC ? date.getUTCMinutes() : date.getMinutes();

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
}

function getLocalDateFromInstant(time, useUTC = false) {
    if (!time) {
        return null;
    }

    const date = new Date(time);

    const year = useUTC ? date.getUTCFullYear() : date.getFullYear();
    const month = (useUTC ? date.getUTCMonth() : date.getMonth()) + 1; // mês começa em 0
    const day = useUTC ? date.getUTCDate() : date.getDate();

    const formattedYear = year.toString();
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');

    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
}

export default { getLocalTimeFromInstant, getLocalDateFromInstant };
